import type { TableProps } from '@aibees/shared/components/table';
import { useDebounceEffect, useSearchParamsSource } from '@aibees/shared/hooks';
import { objectDiff } from '@aibees/shared/utils';
import { isEmpty, isEqual, omit } from 'lodash-es';

export function useFilterChangeListener(table: TableProps) {
  const { params, previousParams } = useSearchParamsSource();

  useDebounceEffect(
    () => {
      if (isEqual(previousParams, params) || !previousParams) return;

      const changedParams = objectDiff(previousParams, params);
      const changedNonePaginationParams = omit(changedParams, 'page', 'size');
      if (isEmpty(changedNonePaginationParams)) return;

      table.onResetPage();
    },
    1,
    [params]
  );
}
